import React, { useState, useRef } from 'react';

const TagInput = ({
  label,
  value = [],
  onChange,
  placeholder = "Type and press Enter to add",
  maxTags = null,
  hint = null
}) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();

      // Check if max tags reached
      if (maxTags && value.length >= maxTags) {
        alert(`Maximum ${maxTags} items allowed`);
        return;
      }

      // Check for duplicates
      if (value.includes(inputValue.trim())) {
        alert('This item already exists');
        setInputValue('');
        return;
      }

      // Add new tag
      onChange([...value, inputValue.trim()]);
      setInputValue('');
    } else if (e.key === 'Backspace' && !inputValue && value.length > 0) {
      // Remove last tag on backspace if input is empty
      onChange(value.slice(0, -1));
    }
  };

  const handleRemove = (indexToRemove) => {
    onChange(value.filter((_, index) => index !== indexToRemove));
  };

  const handleContainerClick = () => {
    inputRef.current?.focus();
  };

  const isNearLimit = maxTags && value.length >= maxTags * 0.8;

  return (
    <div style={{ marginBottom: '20px' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '500',
          color: 'var(--color-text-secondary)',
          marginBottom: '8px'
        }}>
          {label}
        </label>
      )}

      <div
        onClick={handleContainerClick}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          padding: '10px',
          border: '1px solid var(--color-border-strong)',
          borderRadius: '6px',
          background: 'white',
          minHeight: '44px',
          cursor: 'text'
        }}
      >
        {value.map((tag, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 8px',
              background: 'var(--color-info-bg)',
              border: '1px solid var(--color-info-border)',
              borderRadius: '4px',
              fontSize: '13px',
              color: 'var(--color-info-fg)'
            }}
          >
            {tag}
            <button
              onClick={() => handleRemove(index)}
              style={{
                border: 'none',
                background: 'none',
                color: 'var(--color-info)',
                cursor: 'pointer',
                padding: 0,
                width: '16px',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '2px',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              ×
            </button>
          </div>
        ))}

        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={value.length === 0 ? placeholder : ''}
          disabled={maxTags && value.length >= maxTags}
          style={{
            border: 'none',
            outline: 'none',
            flex: 1,
            minWidth: '200px',
            fontSize: '14px',
            padding: '4px',
            background: 'transparent'
          }}
        />
      </div>

      {(hint || maxTags) && (
        <div style={{
          fontSize: '12px',
          color: 'var(--color-text-muted)',
          marginTop: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span>{hint || 'Press Enter to add, Backspace to remove'}</span>
          {maxTags && (
            <span style={{
              color: isNearLimit ? 'var(--color-danger-hover)' : 'var(--color-text-muted)',
              fontWeight: isNearLimit ? '600' : '400'
            }}>
              {value.length}/{maxTags}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TagInput;
